import { Link } from "react-router-dom"
import Paginator from "../../components/Paginator"
import Search from "../../components/Search"
import StandardLayout from "../../components/StandardLayout"
import { removeEmpties } from "../../helper"
import { useQsFilters } from "../../hooks/useFilters"
import { useGiunzioniList } from "../../hooks/giunzioni"

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get("page") ?? 1),
  search: params.get("search") ?? "",
})
const Giunzioni = () => {
  const { filters, uiFilters, setFilters, setFiltersDebounced } = useQsFilters(initFilters)

  const giunzioni = useGiunzioniList(
    removeEmpties({
      search: filters.search,
      page: String(filters.page),
    })
  )

  return (
    <StandardLayout>
      <div className="sticky-header bg-light p-3 shadow-sm">
        <div className="d-flex justify-content-between">
          <div className="page-title">
            <Link to="/dati-base">{"Dati di base"}</Link>
            {` / Giunzioni`}
          </div>
          <Search
            value={uiFilters.search}
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              setFiltersDebounced({ search: e.currentTarget.value, page: 1 })
            }
          />
        </div>
      </div>

      <div className="p-3">
        {giunzioni.data ? (
          <div>
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>{"Loc ref"}.</th>
                  <th>{"ID"}</th>
                </tr>
              </thead>
              <tbody>
                {giunzioni.data.results.map((giunzione) => (
                  <tr key={giunzione.loc_ref}>
                    <td>{giunzione.loc_ref}</td>
                    <td>{giunzione.id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>

      <div className="sticky-footer bg-light border-top">
        <Paginator
          count={giunzioni?.data?.count ?? 0}
          currentPage={uiFilters.page}
          goToPage={(page) => setFilters({ page })}
        />
      </div>
    </StandardLayout>
  )
}

export default Giunzioni
